import { render } from "./ConfirmDialogModal.vue?vue&type=template&id=1a164e56"
import script from "./ConfirmDialogModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__